import * as React from 'react';
import Report from '../powerBIComponents/Report';
import { connect } from 'react-redux'
import * as PBAction from '../../store/actions/powerBIActions'

import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'bootstrap/dist/css/bootstrap.css';


class PowerBIReport extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            embedConfig: {
                settings: {}
            }, intervalId: null, reportVisual: false, number: '4500.76', localization: false, expandedKeys: {}, selectedNodeKey: null, nodes: null, reportId: props.reportId,
        };



        this.changeEmbedConfig = this.changeEmbedConfig.bind(this);
        this.onLaunchReport = this.onLaunchReport.bind(this);
    }
    
    componentDidMount() {
        if (this.props.webapiUrl != null && this.props.userToken != null && this.props.clientName != null) {
            this.props.loadReports(this.props.webapiUrl, this.props.clientName, this.props.userToken);

                if (this.props.webapiUrl != null && this.props.userToken != null) {
                    this.props.getPortParameters(this.props.webapiUrl, this.props.clientName, this.props.username, this.props.userToken);
                }
        }

        let intervalId = setInterval(() => {
            this.props.getApiToken(this.props.webapiUrl)
            this.setState({intervalId})
        }, 1200000) // 20 mins
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reports != this.props.reports) {
            if (this.props.reports.length > 0) {
                this.setState({ reports: this.props.reports }, () => {
                    var reports = this.props.reports;

                    this.onLaunchReport(this.props.reportId, this.props.reportName, this.props.username, this.props.passageGroupingId, this.props.username, this.props.portParameters, this.props.grade);
                });
            }
        }

        if (prevProps.grade != this.props.grade) {
            if (this.props.webapiUrl != null && this.props.userToken != null) {
                this.props.getPortParameters(this.props.webapiUrl, this.props.clientName, this.props.username, this.props.userToken);
            }
        }

        if (prevProps.portParameters != this.props.portParameters) {
            this.onLaunchReport(this.props.reportId, this.props.reportName, null, this.props.passageGroupingId, this.props.username, this.props.portParameters, this.props.grade);
        }

        if (prevProps.folders != this.props.folders) {
            this.setState({ nodes: this.props.folders });
        }

        if (prevProps.reportId != this.props.reportId) {
            this.onLaunchReport(this.props.reportId, null, this.props.pageId, this.props.passageGroupingId, this.props.username, this.props.portParameters, this.props.grade);
        }

        if (prevProps.passageGroupingId != this.props.passageGroupingId) {
            if (this.props.passageGroupingId != null) {
                this.onLaunchReport(this.props.reportId, null, null, this.props.passageGroupingId, this.props.username, this.props.portParameters, this.props.grade);
            }
        }

        if (prevProps.pageId != this.props.pageId) {
            this.onLaunchReport(this.state.reportId, null, this.state.pageId, null, this.props.username, this.props.portParameters, this.props.grade);
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    onEmbedded(embed) {
        /**
         * Commenting out because it's unnecessary
         * - Mason Smith 
         */
        // console.log(`Report embedded: `, embed, this);
    }

    onLaunchReport(reportId, reportName, pageId, passageGroupingId, username, portParameters, grade) {
        var selectedReport = null;
        var reports = this.state.reports;

        if (reports != null) {
            if (reportId != null) {
                for (var i = 0; i < reports.length; i++) {
                    if (reports[i].id == reportId) {
                        selectedReport = reports[i];
                        break;
                    }
                }
            }
            else {
                selectedReport = reports[0];
            }

            if (reportName != null) {
                for (var i = 0; i < reports.length; i++) {
                    if (reports[i].name.includes(reportName)) {
                        selectedReport = reports[i];
                        break;
                    }
                }
            }

            this.changeEmbedConfig(selectedReport, reportId, pageId, passageGroupingId, username, portParameters, grade);
        }
    }

    changeEmbedConfig(selectedReport, reportId, pageId, passageGroupingId, username, portParameters, grade) {
        var filters = [];
        if (passageGroupingId != null) {
            var filterName = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimTCPPassageGroupingNames_JSON",
                    column: "GroupUniqueId"
                },
                operator: 'In',
                values: [passageGroupingId]

            };

            filters.push(filterName);

        }

        if (username != null) {
            var filterName = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "DimVesselGroup_Users_API",
                    column: "Username"
                },
                operator: 'In',
                values: [username]

            };

            filters.push(filterName);

        }

        var embedConfig = this.state.embedConfig;
        embedConfig.id = selectedReport.id;
        if (pageId != null) {
            embedConfig.pageName = pageId;
        }
        embedConfig.embedUrl = selectedReport.embedUrl;
        embedConfig.accessToken = selectedReport.accessToken;
        embedConfig.filters = filters;

        embedConfig.settings = {
            filterPaneEnabled: false, // removes unwanted filter pane (right side)
            navContentPaneEnabled: true // this is the bottom tabs
        };

        this.setState({ selectedReport, reportId, embedConfig, reportVisual: false, localization: false });
    }

    render() {

        if (
            this.state.embedConfig.accessToken === undefined ||
            this.state.embedConfig.id === undefined ||
            this.state.embedConfig.pageName === undefined ||
            this.state.embedConfig.filters === undefined ||
            this.state.embedConfig.embedUrl === undefined ||
            this.state.embedConfig.settings.filterPaneEnabled === undefined ||
            this.state.embedConfig.settings.navContentPaneEnabled === undefined ||
            this.onEmbedded  === undefined
        ) {
            return null;
        }
            
        return (
            <div className='row'>
                <div className='col-md-12 '>
                    <Report
                        accessToken={this.state.embedConfig.accessToken}
                        id={this.state.embedConfig.id}
                        pageName={this.state.embedConfig.pageName}
                        filters={this.state.embedConfig.filters}
                        embedUrl={this.state.embedConfig.embedUrl}
                        filterPaneEnabled={this.state.embedConfig.settings.filterPaneEnabled}
                        navContentPaneEnabled={this.state.embedConfig.settings.navContentPaneEnabled}
                        onEmbedded={this.onEmbedded}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        reports: state.powerBIReducer.reports,
        folders: state.powerBIReducer.folders,
        portParameters: state.powerBIReducer.portParameters
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadReports: (webapiUrl, clientName, userToken) => dispatch(PBAction.loadReports(webapiUrl, clientName, userToken)),
        getPortParameters: (webapiUrl, clientName, username, token) => dispatch(PBAction.getPortParameters(webapiUrl, clientName, username, token)),
        getUserToken: (webapiUrl) => dispatch(PBAction.getUserToken(webapiUrl)),
        getApiToken: (webapiUrl) => dispatch(PBAction.getApiToken(webapiUrl)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PowerBIReport);



// WEBPACK FOOTER //
// ./src/components/i4Reports/PowerBIReport.tsx